import { Component, EventEmitter, Output, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BreadcrumbService } from '../../../../shared/service/breadcrumb.service';
import { SharedDataService } from '../../../../shared/service/shared-data/shared-data.service';
import { NotificationDetailService } from '../../../../modules/settings/user-notification/service/notification-detail.service';
import { EnvironmentService } from '../../../../shared/environment.service';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { PlanningDataService } from 'src/app/shared/service/planning-data.service';

@Component({
  selector: 'app-notification-modal',
  templateUrl: './notification-modal.component.html',
  styleUrls: ['./notification-modal.component.scss'],
})
export class NotificationModalComponent implements OnInit {
  showModal = false;
  notifications: any[] = [];
  filteredNotifications: any[] = []; // Array to store filtered notifications
  loading: boolean = true;

  @Output() modalClosed = new EventEmitter<void>();
  selectedMenu: any = [
    { label: 'Home', url: '/dashboard' },
    { label: 'Notifications', url: '/notification-detail' },
  ];

  constructor(
    private router: Router,
    private breadcrumbService: BreadcrumbService,
    public sharedDataService: SharedDataService,
    private notificationService: NotificationDetailService,
    public envService: EnvironmentService,
    public translate: TranslateService,
    private planningDataService: PlanningDataService,
  ) {}

  ngOnInit(): void {
    this.loadNotifications();
  }

  loadNotifications(status?: string) {
    this.loading = true;
    const params: any = {
      page: 0,
      size: 10,
    };
    // Add status to params only if it's provided
    if (status) {
      params.status = status;
    }
    this.notificationService.fetchAllNotifications(params).subscribe({
      next: (response: any) => {
        if(response?.body?.content?.length>0){
          this.sharedDataService.unreadNotfCount=response?.body?.content[0]?.unReadNotificationCount;
        }
        this.notifications = response.body.content.map((notification: any) => {
          let swapInitUserImage=null;
          let swapTransfUserImage=null;

          // Format date using moment
          const [dateString, timeString] = notification.createdAt.split(' ');

          // Format date dynamically with translation
          const formattedDate = this.getTranslatedRelativeDate(dateString);
  
          // Format time to 24-hour format
          const formattedTime = moment(timeString, ['hh:mm A']).format('HH:mm');
          const formattedDateValue=formattedDate+` ${this.translate.instant('constants.DATE.at')} `+formattedTime
          if(notification.type === 'SWAP_DUTY_APPROVE'){
            swapInitUserImage=notification.intiatedStaffImage
            ? `${this.envService.imgReviewUrl}/${notification.intiatedStaffImage}`
            : 'assets/image/default-avatar.webp';
            swapTransfUserImage=notification.transferStaffImage
            ? `${this.envService.imgReviewUrl}/${notification.transferStaffImage}`
            : 'assets/image/default-avatar.webp'
          }
          return {
            id: notification.id,
            title: notification.title,
            message: notification.message,
            time: formattedDateValue,
            avatar: notification.staff.imageUrl
              ? `${this.envService.imgReviewUrl}/${notification.staff.imageUrl}`
              : 'assets/image/default-avatar.webp',
            swapAvatar: notification?.intiatedStaffImage
            ? `${this.envService.imgReviewUrl}/${notification.intiatedStaffImage}`
            : 'assets/image/default-avatar.webp',
            swapInitUserImage:swapInitUserImage,
            swapTransfUserImage:swapTransfUserImage,
            status: notification.status,
            type: notification.type
          };
        });

        this.filteredNotifications = this.notifications;
        this.loading = false;
      },
      error: (error) => {
        console.error(error);
        this.loading = false;
      },
    });
  }
// Helper function to get translated relative date
getTranslatedRelativeDate(dateString: string): string {
  const date = moment(dateString, 'DD.MM.YYYY');
  const now = moment();

  // Today
  if (now.isSame(date, 'day')) {
    return this.translate.instant('constants.DATE.TODAY');
  }

  // Yesterday
  if (now.subtract(1, 'days').isSame(date, 'day')) {
    return this.translate.instant('constants.DATE.YESTERDAY');
  }

  // Last week
  if (now.subtract(6, 'days').isSameOrBefore(date, 'day')) {
    const weekdayKey = `constants.DATE.${date.format('dddd').toUpperCase()}`;
    return `${this.translate.instant(
      'constants.DATE.LAST'
    )} ${this.translate.instant(weekdayKey)}`;
  }

  // Other dates
  const monthKey = `constants.MONTH.${date.format('MMMM').toUpperCase()}`; // Example: MONTH.JANUARY
  const translatedMonth = this.translate.instant(monthKey);

  // Check if the year is the current year
  if (now.isSame(date, 'year')) {
    // Only display month and day
    return `${translatedMonth} ${date.format('D')}`;
  } else {
    // Display month, day, and year for past years
    return `${translatedMonth} ${date.format('D')}, ${date.format('YYYY')}`;
  }
}
  filterNotifications(tabIndex: number) {
    switch (tabIndex) {
      case 0: // All notifications
        this.loadNotifications(); // No status passed
        break;
    }
  }

  toggleModal() {
    this.showModal = !this.showModal;
    if (this.showModal) {
      this.loadNotifications();
    }
    if (!this.showModal) {
      this.modalClosed.emit();
    }
  }

  closeModal() {
    this.showModal = false;
    this.modalClosed.emit();
  }

  viewAllNotifications() {
    this.router.navigate(['/notification-detail']);
    this.planningDataService.setSelRouterLink('/notification-detail');
    this.closeNotificationModal();
  }

  openNotificationDetail(notification: any) {
    this.planningDataService.setSelRouterLink(`/notification-detail/${notification?.id}`);
    if (notification.status === 'UNREAD') {
      this.notificationService
        .updateNotificationStatus(notification.id)
        .subscribe({
          next: () => {
            this.loadNotifications();
            this.router.navigate(['/notification-detail', notification.id]);
          },
          error: (error) => {
            console.error('Error updating notification status', error);
          },
        });
    }
    else{
      this.router.navigate(['/notification-detail', notification.id]);
    }
    this.closeNotificationModal();
  }

  closeNotificationModal() {
    this.sharedDataService.activeTab = '/notification-detail';
    this.breadcrumbService.updateBreadcrumbs(this.selectedMenu);
    this.closeModal();
  }

  trackByFn(index: number, item: any) {
    return item.id;
  }
}
